import { Rectangle } from "./RectangleTool";
import Konva from "konva";

import { DMCVideo } from "../KObjects/DMCVideo";

export class Video extends Rectangle {
  constructor() {
    super();
    this.name = "Video";
    this.videoSource = "";
    this.realSource = "";
  }

  createControllerObject(name, konvaObject) {
    return new DMCVideo(name, konvaObject, this.realSource);
  }

  createNew(controllerProject) {
    super.createNew(controllerProject);
  }

  mouseUp(creationController) {
    const name = super.mouseUp(creationController);
    this.currentShapeConfig.image.play();
    return name;
  }

  createNewForm() {
    this.currentShapeConfig.image = document.createElement("video");
    this.currentShapeConfig.image.src = this.videoSource;
    const image = new Konva.Image(this.currentShapeConfig);
    this.getRatio(this.currentShapeConfig.image);
    return image;
  }

  getRatio(currentImage) {
    this.ratio = "16:10";
    const poll = setInterval(() => {
      if (currentImage.videoHeight) {
        clearInterval(poll);
        const gcd = this.gcd(currentImage.videoWidth, currentImage.videoHeight);
        this.ratio = currentImage.videoWidth / gcd + ":" + currentImage.videoHeight / gcd;
      }
    }, 10);
  }

  gcd(a, b) {
    return b == 0 ? a : this.gcd(b, a % b);
  }

  mouseDown(controllerProject) {
    this.createNew(controllerProject);
    this.origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    this.origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;
    const imageWidth = this.currentShapeConfig.image.width;
    const imageHeight = this.currentShapeConfig.image.height;
    if (!this.interval) {
      this.interval = setInterval(() => {
        const firstRatio = this.ratio.split(":")[0];
        const secondRatio = this.ratio.split(":")[1];
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        const distanceX = Math.abs(this.origin.x - currentMousePos.x / controllerProject.scale);
        const distanceY = Math.abs(this.origin.y - currentMousePos.y / controllerProject.scale);
        if (distanceX / imageWidth > distanceY / imageHeight) {
          this.currentObject.setAttr("height", distanceY);
          this.currentObject.setAttr("width", (distanceY * firstRatio) / secondRatio);
        } else {
          this.currentObject.setAttr("width", distanceX);
          this.currentObject.setAttr("height", (distanceX * secondRatio) / firstRatio);
        }
        if (currentMousePos.x / controllerProject.scale < this.origin.x) {
          this.currentObject.setAttr("x", this.origin.x - this.currentObject.attrs.width);
        }
        if (currentMousePos.y / controllerProject.scale < this.origin.y) {
          this.currentObject.setAttr("y", this.origin.y - this.currentObject.attrs.height);
        }
        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 30);
    }
  }

  video(listPath) {
    listPath.forEach((path) => {
      this.videoSource = path.replace("public\\", ".\\");
      this.realSource = path;
    });
  }
  singleClickPrevent(controllerProject) {
    if (this.currentObject !== null) {
      if (this.currentObject.attrs.width == 0 && this.currentObject.attrs.height != 0) {
        this.currentObject.setAttr("width", 1);
      } else if (this.currentObject.attrs.height == 0 && this.currentObject.attrs.width != 0) {
        this.currentObject.setAttr("height", 1);
      } else if (this.currentObject.attrs.width == 0 && this.currentObject.attrs.height == 0) {
        this.currentObject.setAttr("width", controllerProject.projectSize.width);
        this.currentObject.setAttr("height", controllerProject.projectSize.height);
        this.currentObject.setAttr("X", 0);
        this.currentObject.setAttr("Y", 0);
      }
    }
  }

  setContent(listPath, name) {
    this.name = name;
    this.video(listPath);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject);
    this.currentObject.setAttr("x", this.edit.x);
    this.currentObject.setAttr("y", this.edit.y);
    this.currentObject.setAttr("width", this.edit.width);
    this.currentObject.setAttr("height", this.edit.height);
    this.currentObject.setAttr("scaleX", this.edit.scaleX);
    this.currentObject.setAttr("scaleY", this.edit.scaleY);
    this.edit = "";
    return this.mouseUp(controllerProject);
  }
}
